import axios from "axios";
import { FETCH_TICKET_ALERT_SETTINGS, FETCH_TICKET_SETTINGS } from "../constants/tickets";

const TICKETS_API_URL = `${process.env.REACT_APP_API_URL}/tickets`;

export const fetchTicketAlertSettings =
  (params) => async (dispatch, getState) => {
    const token = getState().auth.token;
    if (token) {
      const headers = {
        "Content-Type": "application/json",
        Authorization: `Token ${token}`,
      };
      try {
        let response = await axios.get(`${TICKETS_API_URL}/alert-settings/`, {
          headers,
          params,
        });
        if (response.status === 200) {
          dispatch({
            type: FETCH_TICKET_ALERT_SETTINGS,
            data: response.data,
          });
        }
      } catch (error) {
        throw error;
      }
    }
  };

export const createTicketAlertSettings =
  (data) => async (dispatch, getState) => {
    const token = getState().auth.token;
    if (token) {
      const headers = {
        "Content-Type": "application/json",
        Authorization: `Token ${token}`,
      };
      try {
        let response = await axios.post(
          `${TICKETS_API_URL}/alert-settings/`,
          data,
          {
            headers,
          }
        );
        if (response.status === 201) {
          dispatch(
            fetchTicketAlertSettings({ feedback_form: data["feedback_form"] })
          );
        }
      } catch (error) {
        throw error;
      }
    }
  };

export const fetchTicketAlertSettingsChoices =
  (params) => async (dispatch, getState) => {
    const token = getState().auth.token;
    if (token) {
      const headers = {
        "Content-Type": "application/json",
        Authorization: `Token ${token}`,
      };
      try {
        let response = await axios.get(`${TICKETS_API_URL}/get-choices`, {
          headers,
          params,
        });
        if (response.status === 200) {
          return response.data;
        }
      } catch (error) {
        throw error;
      }
    }
  };

export const createTicketSettings =
  (data) => async (dispatch, getState) => {
    const token = getState().auth.token;
    if (token) {
      const headers = {
        "Content-Type": "application/json",
        Authorization: `Token ${token}`,
      };
      try {
        let response = await axios.post(`${TICKETS_API_URL}/settings/`, data, {
          headers,
        });
        if (response.status === 201) {
          return response.data;
        }
      } catch (error) {
        throw error;
      }
    }
  };

  export const updateTicketSettings =
  (ticketSettingsID, formID, data) => async (dispatch, getState) => {
    const token = getState().auth.token;
    if (token) {
      const headers = {
        "Content-Type": "application/json",
        Authorization: `Token ${token}`,
      };
      try {
        const params = {
          feedback_form: formID,
        }
        let response = await axios.put(`${TICKETS_API_URL}/settings/${ticketSettingsID}/`, data, {
          params,
          headers,
        });
        if (response.status === 201) {
          return response.data;
        }
      } catch (error) {
        throw error;
      }
    }
  };
  export const getTicketSettings =
  (params) => async (dispatch, getState) => {
    const token = getState().auth.token;
    if (token) {
      const headers = {
        "Content-Type": "application/json",
        Authorization: `Token ${token}`,
      };
      try {
        let response = await axios.get(`${TICKETS_API_URL}/settings/`, {
          params,
          headers,
        });
        if (response.status === 200) {
          dispatch({
            type: FETCH_TICKET_SETTINGS,
            data: response.data,
          });
        }
      } catch (error) {
        throw error;
      }
    }
  };
